import { jsx } from "react/jsx-runtime";
import AvatarContainer from "./AvatarContainer.js";
import classnames from "classnames";
import { rootClass } from "../constant.js";
function TextAvatar(props) {
    return /*#__PURE__*/ jsx(AvatarContainer, {
        ...props,
        className: classnames(props.className, `${rootClass}__text`),
        children: /*#__PURE__*/ jsx("span", {
            className: "weet-avatar-text",
            children: props?.name?.slice(-2) || ''
        })
    });
}
export { TextAvatar as default };
